import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

export const useKeyPress = (keys: string[], callback: (event: KeyboardEvent) => boolean | void): void => {
    const callbackRef = useRef(callback);
    useLayoutEffect(() => {
        callbackRef.current = callback;
    });

    const handleKeyPress = useCallback(
        (event: any) => {
            // check if one of the key is part of the ones we want
            if (keys.some((key) => event.key === key)) {
                return callbackRef.current(event);
            }
        },
        [keys],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyPress);

        // remove the event listener
        return () => document.removeEventListener('keydown', handleKeyPress);
    }, [handleKeyPress]);
};
